/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Entityfiltername2Inputs */

const en_entity_entityfiltername2 = /** @type {(inputs: Entity_Entityfiltername2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Filter Name`)
};

const de_entity_entityfiltername2 = /** @type {(inputs: Entity_Entityfiltername2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitätenfilter-Name`)
};

/**
* | output |
* | --- |
* | "Entity Filter Name" |
*
* @param {Entity_Entityfiltername2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_entityfiltername2 = /** @type {((inputs?: Entity_Entityfiltername2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Entityfiltername2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entityfiltername2(inputs)
	return de_entity_entityfiltername2(inputs)
});
export { entity_entityfiltername2 as "entity_entityFilterName" }